/**
 * @generated SignedSource<<387b3b5a19d8bd1cc0355c392ec5e036>>
 * @relayHash 80f146a83f48be7b9331f291c6222df0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ExternalByLineQuery$variables = {
  contentId: string;
};
export type ExternalByLineQuery$data = {
  readonly singleContent: {
    readonly history: {
      readonly createdBy: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly createdDate: string | null | undefined;
      readonly lastOwnedBy: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly ownedBy: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly type: string | null | undefined;
    readonly version: {
      readonly by: {
        readonly accountId?: string | null | undefined;
        readonly displayName: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined;
      readonly confRev: string | null | undefined;
      readonly contentTypeModified: boolean | null | undefined;
      readonly friendlyWhen: string | null | undefined;
      readonly number: number | null | undefined;
      readonly syncRev: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ExternalByLineQuery = {
  response: ExternalByLineQuery$data;
  variables: ExternalByLineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v5 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v7 = [
  (v3/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "friendlyWhen"
},
v9 = {
  "kind": "ScalarField",
  "name": "number"
},
v10 = {
  "kind": "ScalarField",
  "name": "confRev"
},
v11 = {
  "kind": "ScalarField",
  "name": "syncRev"
},
v12 = {
  "kind": "ScalarField",
  "name": "contentTypeModified"
},
v13 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v3/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ExternalByLineQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v7/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": (v7/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "lastOwnedBy",
                "plural": false,
                "selections": (v7/*: any*/)
              }
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": (v7/*: any*/)
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalByLineQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "History",
            "kind": "LinkedField",
            "name": "history",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": (v13/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "ownedBy",
                "plural": false,
                "selections": (v13/*: any*/)
              },
              {
                "kind": "LinkedField",
                "name": "lastOwnedBy",
                "plural": false,
                "selections": (v13/*: any*/)
              }
            ]
          },
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": (v13/*: any*/)
              },
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "80f146a83f48be7b9331f291c6222df0",
    "id": "441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962",
    "metadata": {},
    "name": "ExternalByLineQuery",
    "operationKind": "query",
    "text": "query ExternalByLineQuery($contentId:ID!){singleContent(id:$contentId){id,type,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId}},ownedBy{__typename,type,displayName,...on KnownUser{accountId}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,confRev,syncRev,contentTypeModified}}}"
  }
};
})();

(node as any).hash = "012bf9a7497572d73e22134c755e8758";

export default node;
